import React from "react";

type TUserAvatarProps = {
    userName: string | null;
    size?: number;
    fontSize?: number;
};

const UserAvatar: React.FC<TUserAvatarProps> = ({
    userName,
    size = 24,
    fontSize = 12,
}) => {
    const getInitials = (name: string | null): string => {
        if (!name) return "?";

        const parts = name.trim().split(" ");
        if (parts.length >= 2) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    const getBackgroundColor = (name: string | null): string => {
        if (!name) return "#999";

        const colors = [
            "#0088cc", // teal
            "#e85d75", // pink
            "#50c878", // emerald
            "#ff8c42", // orange
            "#9d4edd", // purple
            "#4285f4", // blue
            "#ea4335", // red
            "#34a853", // green
        ];

        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        return colors[Math.abs(hash) % colors.length];
    };

    const initials = getInitials(userName);
    const bgColor = getBackgroundColor(userName);

    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: bgColor,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize,
                fontWeight: 600,
                flexShrink: 0,
            }}
            title={userName ?? "Unknown User"}
        >
            {initials}
        </div>
    );
};

export default UserAvatar;
